<template>
  <div class="settings-user">
    <h2>{{ $t('settings.current_user.title') }}: {{ user.login || '' }}</h2>
    <div v-if="!loading">
      <b-field horizontal :label="$t('settings.change.name')">
        <b-input
          :placeholder="$t('settings.user.name')"
          name="name"
          v-model="userModel.name"
          v-validate="'required'"
        ></b-input>
      </b-field>
      <b-field horizontal :label="$t('settings.change.password')">
        <b-input
          type="password"
          name="password"
          placeholder="password"
          v-model="userModel.password"
          v-validate="'required'"
          icon-pack="fas"
          password-reveal
        ></b-input>
      </b-field>
      <edit-button :editOptions="['save']" @click="save">
        <template>
          <span class="text">{{ $t('button.save') }}</span>
        </template>
      </edit-button>
    </div>
    <loader v-else></loader>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import EditButton from '@/components/EditButton'

export default {
  props: ['user', 'loading'],
  data() {
    return {
      userModel: null
    }
  },
  components: {
    EditButton,
    Loader
  },
  methods: {
    save() {
      if (this.userModel.hasOwnProperty('password') && !this.userModel['password']) {
        delete this.userModel['password']
      }
      this.$emit('save', this.userModel)
    },
    setUser(newUser) {
      this.userModel = newUser
    },
    cancel() {
      this.setUser(this.user)
    }
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler: 'setUser'
    }
  }
}
</script>

<style lang="scss">
.settings-user {
  margin-bottom: 3rem;
  .field {
    input {
      font-size: 0.9rem;
      height: 1.5rem;
    }
    .has-icons-right {
      .icon {
        font-size: 0.6875rem;
        right: 0.3125rem;
      }
    }
  }
}
</style>
